export const COVERAGE_TABLE_STORAGE_KEY = 'coverage_table';
